import React from "react";
const AboutUs = () => {
  return (
    <section id="about" className="section custom-bg-dark">
      <div className="container">
        {/* Heading */}
        <p className="text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">About Me</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp text-white">
          Know Me More
        </h2>
        {/* Heading end*/}
        <div className="row text-white">
          <div className="col-lg-8 text-center text-lg-start wow fadeInUp">
            <h2 className="text-8 fw-400 mb-3">
              Hi, I'm{" "}
              <span className="fw-700 border-bottom border-3 border-primary">
                Mohamed El Nimr
              </span>
            </h2>
            <p className="text-5">
              I'm passionate about system and network management. 
              I enjoy solving complex IT problems and exploring new technologies. 
              I like working with others and always look for ways to improve myself 
              and add value to every project.
            </p>
          </div>
          <div
            className="col-lg-4 mt-4 mt-lg-0 wow fadeInUp"
            data-wow-delay="0.2s"
          >
            <div className="featured-box style-4">
              <div className="featured-box-icon text-25 fw-500 bg-primary rounded-circle">
                <span className="wow heartBeat" data-wow-delay="1.3s">
                  2
                </span>
              </div>
              <h3 className="text-7 wow rubberBand" data-wow-delay="2s">
                Years of <span className="fw-700">System & Networking Experience</span>
              </h3>
            </div>
          </div>
        </div>
        <div className="row gy-3 mt-4">
          {/* <div className="col-6 col-lg-3 wow fadeInUp">
            <p className="text-muted fw-500 mb-0">Name:</p>
            <p className="text-4 text-white fw-600 mb-0">Mohamed El Nimr</p>
          </div> */}
          <div className="col-8 col-lg-4 wow fadeInUp" data-wow-delay="0.2s">
            <p className="text-muted fw-500 mb-0">Email:</p>
            <p className="text-4 fw-600 mb-0">
              <a className="truncate" href="mailto:elnimr.mohamed2703@hotmail.com">
                elnimr.mohamed2703@hotmail.com
              </a>
            </p>
          </div>
          <div className="col-6 col-lg-3 wow fadeInUp" data-wow-delay="0.3s">
            <p className="text-muted fw-500 mb-0">Date of birth:</p>
            <p className="text-4 text-white fw-600 mb-0">2 July, 2003</p>
          </div>
          <div className="col-6 col-lg-3 wow fadeInUp" data-wow-delay="0.4s">
            <p className="text-muted fw-500 mb-0">From:</p>
            <p className="text-4 text-white fw-600 mb-0">Geel, Belgium.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
